<header>
  <button mat-icon-button (click)="close()" class="close-button">
    <mat-icon svgIcon="close_v2"></mat-icon>
  </button>
</header>
<div (swipeleft)="onSwipeLeft()" (swiperight)="onSwipeRight()" (swipedown)="close()" (swipeup)="close()">
  <ng-container [ngTemplateOutlet]="selected?.content"></ng-container>
</div>
<!-- This is the navigation bar of the stepper -->
<footer class="onboarding-footer">
  @if (selectedIndex === 0) {
    <button mat-button (click)="close()">
      <span translate>ONBOARDING.SKIP_TOUR</span>
    </button>
    <button mat-raised-button color="primary" cdkStepperNext>
      <span translate>ONBOARDING.START_TOUR</span>
    </button>
  } @else {
    <div class="desktop">
      <button mat-button color="primary" cdkStepperPrevious>
        <span translate>LABEL.BACK</span>
      </button>
      <app-onboarding-step-navigator
        [stepControlSteps]="stepControlSteps"
        (stepClicked)="onClick($event)"
      [selectedIndex]="selectedIndex"></app-onboarding-step-navigator>
      @if (selectedIndex !== stepControlSteps.length) {
        <button mat-raised-button color="primary" cdkStepperNext>
          <span translate>LABEL.NEXT</span>
        </button>
      }
      @if (selectedIndex === stepControlSteps.length) {
        <button mat-raised-button color="primary" (click)="close()">
          <span translate>ONBOARDING.FINISH_TOUR</span>
        </button>
      }
    </div>
    <div class="mobile">
      <app-onboarding-step-navigator
        [stepControlSteps]="stepControlSteps"
        (stepClicked)="onClick($event)"
      [selectedIndex]="selectedIndex"></app-onboarding-step-navigator>
      <div class="buttons">
        <button mat-button cdkStepperPrevious>
          <span translate>LABEL.BACK</span>
        </button>
        @if (selectedIndex !== stepControlSteps.length) {
          <button mat-raised-button color="primary" cdkStepperNext>
            <span translate>LABEL.NEXT</span>
          </button>
        }
        @if (selectedIndex === stepControlSteps.length) {
          <button mat-raised-button color="primary" (click)="close()">
            <span translate>ONBOARDING.FINISH_TOUR</span>
          </button>
        }
      </div>
    </div>
  }

  <ng-template #footer>
    <div class="desktop">
      <button mat-button color="primary" cdkStepperPrevious>
        <span translate>LABEL.BACK</span>
      </button>
      <app-onboarding-step-navigator
        [stepControlSteps]="stepControlSteps"
        (stepClicked)="onClick($event)"
      [selectedIndex]="selectedIndex"></app-onboarding-step-navigator>
      @if (selectedIndex !== stepControlSteps.length) {
        <button mat-raised-button color="primary" cdkStepperNext>
          <span translate>LABEL.NEXT</span>
        </button>
      }
      @if (selectedIndex === stepControlSteps.length) {
        <button mat-raised-button color="primary" (click)="close()">
          <span translate>ONBOARDING.FINISH_TOUR</span>
        </button>
      }
    </div>

    <div class="mobile">
      <app-onboarding-step-navigator
        [stepControlSteps]="stepControlSteps"
        (stepClicked)="onClick($event)"
      [selectedIndex]="selectedIndex"></app-onboarding-step-navigator>

      <div class="buttons">
        <button mat-button cdkStepperPrevious>
          <span translate>LABEL.BACK</span>
        </button>

        @if (selectedIndex !== stepControlSteps.length) {
          <button mat-raised-button color="primary" cdkStepperNext>
            <span translate>LABEL.NEXT</span>
          </button>
        }
        @if (selectedIndex === stepControlSteps.length) {
          <button mat-raised-button color="primary" (click)="close()">
            <span translate>ONBOARDING.FINISH_TOUR</span>
          </button>
        }
      </div>
    </div>
  </ng-template>
</footer>
